/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import * as default_data from '../../config.js'
import * as log from 'loglevel'
import { getToken } from '../../AuthService.js';

async function addMemo(workbook_id, title, type, content, references, references_descriptions) {
  try {

    var token = getToken()
    if(token === false) {
      return {'response': 'Please login again', 'status': 400};
    }

    const response = await fetch(default_data.default_user_service_url_no_cac + '/memo', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },
        body: JSON.stringify({
          workbook_id: workbook_id,
          title: title,
          type: type,
          content: content,
          references: references,
          references_descriptions: references_descriptions          
        })
      })
      
      const data = await response.json();
      if(data.status != 200) {
        return {'response': data.response, 'status': 400};
      }
      return {'response': 'OK', 'status': 200};
    }
    catch (error) {
      log.error('Error:', error);
      return {'response': 'An error occurred while getting data.', 'status': 400};
    }
  };

  function getFilteredMemoContent(selectedMemos) {

    // list through dictionary and get key and object
    var memos = [];
    for (var key in selectedMemos) {
      if (selectedMemos.hasOwnProperty(key)) {
        memos.push(selectedMemos[key]);
      }
    }
    var ret = [];
    for(var i = 0; i < memos.length; i++) {
      var section = i + 1;
      ret.push('Memo: ' + memos[i].content);
    }
    // return aggregated full_text into string separated by \n
    return ret.join('\n');    
  }

  async function deleteMemo(memo_id) {
    try {
  
      var token = getToken()
      if(token === false) {
        return {'response': 'Please login again', 'status': 400};
      }
  
      const response = await fetch(default_data.default_user_service_url_no_cac + '/memo', {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },
          body: JSON.stringify({
            memo_id: memo_id
          })
        })
        
        const data = await response.json();
        if(data.status != 200) {
          return {'response': data.response, 'status': 400};
        }
        return {'response': 'OK', 'status': 200};
      }
      catch (error) {
        log.error('Error:', error);
        return {'response': 'An error occurred while deleting data.', 'status': 400};
      }
    };
  
  export { addMemo, deleteMemo, getFilteredMemoContent};